import { InjectionToken } from '@angular/core';
import { LabTestResult } from '../lab-test-results/lab-test-result';
import { Observable } from 'rxjs';

export const SUBJECT_LAB_TESTS_DATA_SOURCE = new InjectionToken<SubjectLabTestsDataSource>('SubjectLabTestsDataSource');

export interface SubjectLabTestsDataSource {
    labTestResults: Observable<LabTestResult[]>;
}